import moment from 'moment'

function calculateExpirationTime (expiresIn) {
  const now = new Date().getTime();
  return now + expiresIn * 1000;
}

function filterObjectByMonths (obj, key, months, toDate=null, skipInvalidDate=false) {
  toDate = toDate ? toDate : new Date();
  const fromDate = toDate.setMonth(toDate.getMonth() - months);

  return obj.filter(elem => {
    if (!obj[key] & !skipInvalidDate) {
      return true;
    }
    return obj[key] >= fromDate & obj[key] <= toDate;
  })
}

function fromNow(date, abbreviation = false) {
  const ret = moment(date).fromNow();
  return !abbreviation ? ret : ret.replace('an ', '1 ').replace('a ', '1 ').replace('1 few', 'a few').replace('ago', '').replace('seconds', 's').replace('second', 's').replace('minutes', 'min').replace('minute', 'min').replace('hours', 'h').replace('hour', 'h').replace('days', 'd').replace('day', 'd').replace('weeks', 'w').replace('week', 'w').replace('months', 'm').replace('month', 'm').replace('years', 'y').replace('year', 'y');
}

function getDurationFromNow (timestamp, abbreviate = false) {
  const now = moment();
  const then = moment(timestamp);
  const diff = moment.duration(now.diff(then));

  if (abbreviate) {
    if (diff.years() > 0) {
      return `${diff.years()}y`;
    } else if (diff.months() > 0) {
      return `${diff.months()}mo`;
    } else if (diff.weeks() > 0) {
      return `${diff.weeks()}w`;
    } else if (diff.days() > 0) {
      return `${diff.days()}d`;
    } else if (diff.hours() > 0) {
      return `${diff.hours()}h`;
    } else if (diff.minutes() > 0) {
      return `${diff.minutes()}m`;
    } else {
      return `${diff.seconds()}s`;
    }
  } else {
    if (diff.years() > 0) {
      return `${diff.years()} year${diff.years() > 1 ? 's' : ''}`;
    } else if (diff.months() > 0) {
      return `${diff.months()} month${diff.months() > 1 ? 's' : ''}`;
    } else if (diff.weeks() > 0) {
      return `${diff.weeks()} week${diff.weeks() > 1 ? 's' : ''}`;
    } else if (diff.days() > 0) {
      return `${diff.days()} day${diff.days() > 1 ? 's' : ''}`;
    } else if (diff.hours() > 0) {
      return `${diff.hours()} hour${diff.hours() > 1 ? 's' : ''}`;
    } else if (diff.minutes() > 0) {
      return `${diff.minutes()} minute${diff.minutes() > 1 ? 's' : ''}`;
    } else {
      return `${diff.seconds()} second${diff.seconds() > 1 ? 's' : ''}`;
    }
  }
}

function getLocaleDateString(date, timezone, format = 'll') {
  if (!date) {
    return '';
  }

  const localeDate = new Date(date.toLocaleString('en-US', { timezone: timezone }));
  return moment(localeDate).format(format);
}

function isAfterToday(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(date) > today;
}

function isBeforeToday(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(date) < today;
}

function parseTimestampInDatabase (timestampString) {
  return timestampString ? moment(timestampString, 'YYYY-MM-DD HH:mm:ssZ').toDate() : null;
}

function replaceTimestampInObject (obj, key) {
  obj.forEach(elem => {
    elem[key] = parseTimestampInDatabase(elem[key]);
  })
  return obj;
}

export {
  calculateExpirationTime,
  filterObjectByMonths,
  fromNow,
  getDurationFromNow,
  getLocaleDateString,
  isAfterToday,
  isBeforeToday,
  parseTimestampInDatabase,
  replaceTimestampInObject,
};
